module.exports = __webpack_public_path__ + "tick_small.b4bcfe5a2c692c2b33d35ecca51a9fe2.png";